import { gql } from '@apollo/client'

export const SABRE_CREATE_CATEGORY = gql`
  mutation CreateCategory($input: CreateCategoryInput!) {
    createCategory(input: $input) {
      category {
        id
        name
        parent {
          id
          name
        }
      }
    }
  }
`
